import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTablesDefinitionAction, importTableDefinitionAction } from "../actions";
import {
    getLoading,
    getData,
    getCodeList,
    getAccessTypeList,
    getProcessList,
    getDetailTableList,
    getUserMenuList,
} from "../selectors";
import { getAppColor, getIsAdmin } from "@icarius-app/selectors";
import { Grid } from "@material-ui/core";
import DataItem from "./data/dataItem";
import { RESET_STATE } from "../actionTypes";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import { useHistory } from "react-router-dom";
import paths from "@icarius-router/paths";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { importIcariusFile } from "@icarius-utils/exportImportIcarius";
import { getLocalizedString } from "@icarius-localization/strings";

const SystemAndUserTablesDefinition = ({ isSystemTables, handleOpenTableFieldsPage }) => {
    const [createIsOpen, setCreateIsOpen] = useState(false);

    const dispatch = useDispatch();
    const history = useHistory();

    const isAdmin = useSelector(getIsAdmin);

    const color = useSelector(getAppColor);
    const data = useSelector(getData);

    const codeList = useSelector(getCodeList);
    const accessTypeList = useSelector(getAccessTypeList);
    const processList = useSelector(getProcessList);
    const detailTableList = useSelector(getDetailTableList);
    const userMenuList = useSelector(getUserMenuList);
    const isLoading = useSelector(getLoading);

    useEffect(() => {
        dispatch(getTablesDefinitionAction(isSystemTables));
        return () => {
            dispatch({ type: RESET_STATE });
        };
    }, [dispatch, isSystemTables]);

    const getDataIsEmpty = () => {
        return !data || data.length === 0;
    };

    const handleImport = () => {
        const importCallback = (parsedObject) => {
            if (parsedObject.query && parsedObject.parameters) {
                dispatch(importTableDefinitionAction(isSystemTables, parsedObject)).then((response) => {
                    if (response.data.status === "OK") {
                        dispatch(getTablesDefinitionAction(isSystemTables));
                    }
                });
            } else {
                dispatch(
                    openSnackbarAction({
                        msg: getLocalizedString("theFileYouAreTryingToImportIsDamaged"),
                        severity: "error",
                    })
                );
            }
        };

        importIcariusFile(dispatch, importCallback);
    };

    const customItems = (
        <>
            <CustomIconButton
                title={getLocalizedString("goBack")}
                onClick={() => history.push(paths.extensibilityScreenSelector)}
                type={"goBack"}
            />
            <CustomIconButton
                title={getLocalizedString("importTableDefinition")}
                onClick={handleImport}
                type={"upload"}
            />
        </>
    );

    return (
        <ABMLayout
            title={
                isSystemTables ? getLocalizedString("systemTableDefinition") : getLocalizedString("userTableDefinition")
            }
            isLoading={isLoading}
            showCreateButton={!createIsOpen && isAdmin}
            createButtonTitle={
                isSystemTables ? getLocalizedString("newSystemTable") : getLocalizedString("newUserTable")
            }
            createButtonOnClick={() => setCreateIsOpen(true)}
            showNoData={getDataIsEmpty()}
            noDataTitle={
                isSystemTables ? getLocalizedString("noSystemTableFound") : getLocalizedString("noUserTableFound")
            }
            noDataCreateTitle={
                isSystemTables ? getLocalizedString("newSystemTable") : getLocalizedString("newUserTable")
            }
            noDataOnClick={() => setCreateIsOpen(true)}
            customItems={[customItems]}
            useCustomItemsEnd
        >
            {createIsOpen && (
                <Grid container item xs={12} style={{ margin: "10px 0px" }}>
                    <DataItem
                        color={color}
                        data={null}
                        codeList={codeList}
                        accessTypeList={accessTypeList}
                        processList={processList}
                        userMenuList={userMenuList}
                        detailTableList={detailTableList}
                        closeNew={() => setCreateIsOpen(false)}
                        isAdmin={isAdmin}
                        isSystemTables={isSystemTables}
                    />
                </Grid>
            )}
            {data?.map((item) => {
                return (
                    <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.internalCode}>
                        <DataItem
                            data={item}
                            codeList={codeList}
                            accessTypeList={accessTypeList}
                            processList={processList}
                            userMenuList={userMenuList}
                            detailTableList={detailTableList}
                            color={color}
                            handleOpenTableFieldsPage={handleOpenTableFieldsPage}
                            isAdmin={isAdmin}
                            isSystemTables={isSystemTables}
                        />
                    </Grid>
                );
            })}
        </ABMLayout>
    );
};

export default SystemAndUserTablesDefinition;
